const VALUE_KEYS = ['Value', 'value', 'uuid', 'Uuid'] as const

/**
 * Возвращает значение из объекта, полученного от backend или frontend.
 * Примитивы и объекты без известного ключа возвращаются без изменений.
 */
export const getValueFromObject = (value: unknown): unknown => {
  if (typeof value !== 'object' || value === null) return value

  const valueObject = value as Record<string, unknown>
  const key = VALUE_KEYS.find(key => Object.prototype.hasOwnProperty.call(valueObject, key))

  return key === undefined ? value : valueObject[key]
}
